<template>
  <mu-row gutter>
    <mu-col desktop="100" tablet="100" width="100">

      <alert type="warning" icon="warning" v-if="$store.state.user.scope.has_email_sent === false && !hasSent" align="top">
        <div slot="content">Please confirm your account by email!
          <br/>
          <a
            href="#"
            slot="action"
            class="pointer"
            v-if="!isSending"
            v-text="$store.state.user.scope.has_email_sent ? 'Resend email': 'Send email'"
            @click="sendConfirmationEmail"></a>
          <a
            href="#"
            slot="action"
            class="pointer"
            v-if="isSending"
            :disabled="isSending"
            v-text="isSending ? 'Sending...': 'Done!'"
            @click="sendConfirmationEmail"></a>
        </div>
      </alert>

      <alert type="success" icon="check" v-if="$store.state.user.scope.has_email_sent && !hasSent" align="top">
        <div slot="content">
          You have already been sent an account activation email. Please check your email inbox to find it (have a look in
          the spam folder too, just in case it was sorted into there by mistake!)
          <br/>
          <a
            href="#"
            slot="action"
            class="pointer"
            v-if="!isSending"
            v-text="$store.state.user.scope.has_email_sent ? 'Resend email': 'Send email'"
            @click="sendConfirmationEmail"></a>
          <a
            href="#"
            slot="action"
            class="pointer"
            v-if="isSending"
            :disabled="isSending"
            v-text="isSending ? 'Sending...': 'Done!'"
            @click="sendConfirmationEmail"></a>
        </div>
      </alert>

      <alert type="success" icon="check" v-if="hasSent" align="top">
        <div slot="content">
          Please check your email inbox for an account activation email. If you cannot find it, please check your spam
          folder in case it was sorted into there by mistake!
          <br/>
          <a
            href="#"
            slot="action"
            class="pointer"
            v-if="!isSending"
            v-text="$store.state.user.scope.has_email_sent ? 'Resend email': 'Send email'"
            @click="sendConfirmationEmail"></a>
          <a
            href="#"
            slot="action"
            class="pointer"
            v-if="isSending"
            :disabled="isSending"
            v-text="isSending ? 'Sending...': 'Done!'"
            @click="sendConfirmationEmail"></a>
        </div>
      </alert>
    </mu-col>
  </mu-row>
</template>
<script>
  import AccountApi from '../../api/Account'
  import Alert from "../Alert/Alert";

  export default {
    components: {Alert},
    name: 'email-verification-panel',
    data() {
      return {
        hasSent: false,
        isSending: false
      }
    },
    methods: {
      sendConfirmationEmail() {
        let self = this;
        self.isSending = true;
        AccountApi.sendAccountVerification()
          .then(function () {
            self.hasSent = true;
            self.isSending = false;
          });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// EmailVerification.vue?48a49ab7